<template>
  <section class="delivery">
    <div class="delivery__wrapper">
      
      
      <h2 class="title">Доставка</h2>
      <ul>
        <li class="delivery__item">
          <br />
          <ul class="sub-title">
           <strong style="font-size:0.8em">В МЕЖАХ СМТ.СТРИЖАВКА:</strong> <br />
            <li class="item-ul">Безкоштовна доставка при замовленні від 250 грн.</li>
            <li class="item-ul">В межах селища доставка протягом 60-90 хвилин</li>
            <li class="item-ul">
              Мінімальне замовлення на доставку 150 грн при цьому вартість
              доставки 30 грн.
            </li>
          </ul>
        </li>
        <li class="delivery__item">
          <br />
          <ul class="sub-title">
           <strong style="font-size:0.8em"> У ВІДДАЛЕНІ РАЙОНИ:</strong>
            <li class="item-ul">Безкоштовна доставка при замовленні від 500 грн</li>
            <li class="item-ul">
              Мінімальне замовлення 250 грн при цьому вартість доставки 40 грн
            </li>
            <li class="item-ul">
              с. Гущинці мінімальна сума замовлення 500 грн
            </li>
          </ul>
        </li>
      </ul>
      <br/>
      <br/>
      <h2 class="title">Оплата</h2>
      <p style="color:white">
        <ul class="sub-title">
            <li class="item-ul">Готівкою кур'єру, при отриманні замовлення</li>
            <li class="item-ul">Через систему онлайн оплати LiqPay - Приват24
            </li>
          </ul>
      </p>
      <img
        class="delivery__img"
        src="~@/assets/images/delivery-service.png"
        alt=""
      />
    </div>
  </section>
</template>
<style lang="scss" scoped>
.delivery {
  background: url("~@/assets/images/delivery_background.jpg");
  background-size: cover;
  background-repeat: no-repeat;
  background-position: top;
  padding: 0;
  min-height: 100vh;
  line-height: 1.2;
}
.delivery__wrapper {
  background: #000000c2;
  min-height: 100vh;
  display: flex;
  flex-direction: column;
  align-items: center;
  justify-content: center;
  padding-top: 10vh;
  font-size: x-large;
}
.delivery__img {
  max-height: 25vh;
  margin: 5vh 4vh 0 auto;
}
li,
ul {
  padding: 0 1vh;
  margin: 0;
}
.item-ul{
 font-style: italic;
 font-family: unset;
}
.sub-title li::before {content: "•"; color: rgb(0, 248, 0); margin-right: 10px; }
.title {
  color: #f9ff9a;
  margin: 0;
  padding: 2vh 4vh;
  font-family: monospace;
  font-size: 1.6em;
  font-style: italic;
}
.sub-title {
  font-style: italic;
  color: #1d951d;
}
.sub-title li {
  // list-style-type: circle;
  list-style-type: none;
}

@media only screen and (max-width: 767px) {
  .delivery__wrapper {
    font-size: inherit;
  }
  .delivery__item {
    font-size: 1.1em;
  }
  .title{
    font-size: 2em;
  }
  .sub-title strong, .item-ul{
    font-size: 1.1em!important;
  }
}

@media (min-width: 768px) and (max-width: 850px) {
}

@media (min-width: 851px) {
}
</style>
